// Main App Component

import { MainLayout } from './components/layout/MainLayout';
import { useUserStore } from './stores';

function App() {
  const { user, setUser } = useUserStore();

  // Check for stored user on mount
  // In a real app, this would validate the session with the backend
  // For now, we'll just use a mock user for development
  // setUser({
  //   id: 'dev-user-1',
  //   email: 'dev@example.com',
  //   name: 'Dev User',
  //   plan: 'pro',
  //   credits: 10000,
  //   createdAt: new Date().toISOString(),
  // });

  return (
    <MainLayout />
  );
}

export default App;